export default "__VITE_ASSET__DyNLdLlB__"